/**
 * Marks a Demand configuration page element the rail's items scroll to: a section carries its section
 * key, an insight row its insight key.
 */
export const STRATEGY_TARGET_ATTR = "data-strategy-target"

/** `ExpandableCardContent` animates its height open over 0.28s. */
export const CARD_OPEN_MS = 300
